<template>
    <tr class="h-12 w-full whitespace-nowrap bg-gray-100 absolute bottom-0 flex items-center border-t border-gray-300 font-medium  text-gray-800 tracking-wide">
        <td :colspan="columnSpan" class="bg-gray-100">
            <div class="flex w-full justify-start items-center">
                <div class="pl-3 whitespace-nowrap flex space-x-2">
                    <div class="whitespace-nowrap">
                        Results: {{ count }}
                    </div>
                    <div class="whitespace-nowrap" v-if="selectedResults.length > 0">
                        ( {{ selectedResults.length }} Selected )
                    </div>
                </div>
            </div>
        </td>
    </tr>
</template>

<script setup>
import { ref, defineProps, defineEmits, computed } from 'vue';

const props = defineProps([
    'count',
    'selectedResults',
])


const columnSpan = computed(() => {
    switch(props.viewType) {
        case 'imports':
            return 9
        case 'companies':
            return 7
        default:
            return 0
    }
})
</script>